import { createFromIconfontCN } from '@ant-design/icons';

const IconFont = createFromIconfontCN({
  scriptUrl: "//at.alicdn.com/t/c/font_4324513_aj3n6kxfibl.js",
});

export default IconFont;